// extracted by mini-css-extract-plugin
module.exports = {"ButtonModalContainer":"ConfirmationModal_ButtonModalContainer__1pORP","ModalHeader":"ConfirmationModal_ModalHeader__23df0","BtnNo":"ConfirmationModal_BtnNo__4oy5y"};